/**
 * Animated Pulse Media logo — animated WebP from PNG sequence (transparent, looped).
 * No glow / drop-shadow — pure clean rendering.
 */
export default function LogoAnimation({ size = 84, className = "" }) {
  return (
    <div
      className={`relative inline-flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
    >
      <img
        src="/assets/logo-anim.webp"
        alt="Pulse Media"
        className="relative z-10 w-full h-full object-contain"
        data-testid="logo-animation-video"
      />
    </div>
  );
}
